export const getEnvironment = () => {
  const hostname = window.location.hostname;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'local';
  } else if (hostname.includes('dev.gundiservice.org')) {
    return 'dev';
  } else if (hostname.includes('stage.gundiservice.org')) {
    return 'stage';
  } else {
    return 'production';
  }
};
